<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.position }}</td>
                            <td v-bind:style="{ 'color': item.is_active == 1 ? '#0059b3' : '#e63900'}">{{ item.is_active == 1 ? 'Kích hoạt' : 'Đã khóa' }}</td>
                            <td class="text-center">
                                <v-icon medium class="mr-2" @click="openItem(item.id)">edit</v-icon>
                                <v-icon medium @click="deleteItem(item.id)" v-if="adminRole">delete</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogItem" max-width="800px">
      <v-form ref="validate_form" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="title">Chi tiết danh mục</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Tên danh mục" v-model="currentItem.name" class="input-group--focused" :rules="require_validation"></v-text-field>
              </v-flex>
              <v-flex lg12>
                <h-currency-input label="Vị trí" v-model="currentItem.position" class="input-group--focused" :decimal="0"></h-currency-input>
              </v-flex>
              <v-flex lg12>
                <v-switch label="Kích hoạt" v-model="currentItem.is_active" class="input-group--focused"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
          <v-btn @click="editItem" v-if="!csRole && !saleRole">Cập nhật</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            require_validation: [(v) => !!v || "Trường dữ liệu không được để trống."],
            viewName: "supplier_list",
            dialogItem: false,
            role_list: configs.ROLES,
            headers: [{
                    text: "ID",
                    value: "id",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tên danh mục",
                    value: "name",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Vị trí",
                    value: "position",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Kích hoạt",
                    value: "is_active",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        loading() {
          this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: this.csRole || this.saleRole});
        }
    },
    computed: {
      ...mapState({
        items: state => state.categories.all.data,
        total_rows: state => state.categories.all.total,
        loading: state => state.categories.loading,
        currentItem: (state) => state.categories.selected
      }),
      saleRole() {
        return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Sale;
      },
      csRole() {
        return this.$store.state.authentication.user.role == configs.ROLE_TYPE.CustomerSercice;
      },
      adminRole() {
        return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
      },
      managerRole() {
        return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Manager;
      },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("categories/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openItem: function (id) {
            if(!id) {
                this.$store.commit("categories/setDetail", {'id': id});
            }
            else {
                this.$store.dispatch("categories/getDetail", id);
            }
            this.dialogItem = true;
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        editItem() {
          if(this.$refs.validate_form.validate()) {
            this.$store.dispatch("categories/setDetail", {
                'data': {...this.currentItem},
                'id': this.currentItem.id
            });
            this.dialogItem = false;
          }
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: false});
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("categories/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
